import script from "./CheckboxgroupElement_blocks.vue?vue&type=script&lang=js"
export * from "./CheckboxgroupElement_blocks.vue?vue&type=script&lang=js"

import "./CheckboxgroupElement_blocks.vue?vue&type=style&index=0&id=a8973916&lang=scss"

const __exports__ = script;

export default __exports__